import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GuideService {
  apiURL = environment.BACKEND_URL + '/guides';

  constructor(private http: HttpClient) {}

  getGuides(): Observable<any> {
    return this.http.get(this.apiURL);
  }
}
